import platforms from '@/platformConfig';

const PLATFORM_KEYS = new Set(platforms.map(p => p.toLowerCase()));

/**
 * Split a pathname into feature route segments for the doc and video menus.
 *
 * REMUS routes are platform-prefixed (`/PROD/...`, `/TEST/...`); the leading
 * platform segment is dropped so the menus key pages off the feature route
 * rather than the platform. Project-owned: the HSE harness seeds this file when
 * missing but never overwrites this version.
 */
export function getRouteSegments(pathname: string): string[] {
    const segments = pathname.split('/').filter(Boolean);
    if (segments.length > 0 && PLATFORM_KEYS.has(segments[0].toLowerCase())) {
        return segments.slice(1);
    }
    return segments;
}
